































import { OWebAccountRecovery } from "oweb";
import BaseComponent from "@/components/BaseComponent.vue";
import app from "@/app";
import { Component } from "vue-property-decorator";

@Component
export default class WUserAccountRecoveryTwo extends BaseComponent {
	captcha = app.store.routeContext.getStateItem("captcha");
	form = getForm();

	sendForm(event: any) {
		let form: HTMLFormElement = event.target,
			o = new OWebAccountRecovery(app);

		o.onError(function(response) {
			app.view.dialog(response);
		})
			.onNextStep(function(response) {
				app.router
					.forceNextReplace()
					.browseTo("/me/recover/three", response.data);
			})
			.stepValidate(form);
	}
}

const getForm = function() {
	return {
		fields: {
			code: {
				field: "input",
				label: { i18n: "OO_LANG_VERIFICATION_CODE" },
				attrs: {
					name: "code",
					maxlength: 6,
					autocomplete: "off"
				},
				i18n: {
					placeholder: "OO_LANG_ENTER_CODE"
				}
			},
			submit: {
				field: "submit",
				i18n: "OO_LANG_CHECK_BTN"
			}
		}
	};
};
